import { Courses } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints для admin-backend /courses/*.
 * Read-only режим: list (всех статусов) и get details.
 * admin-backend на порту 5002 без префикса /admin.
 */
export const coursesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listCourses: build.query<
            Courses.GetCoursesResponse,
            Courses.GetCoursesRequest | void
        >({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.search) {
                    search.search = params.search;
                }
                if (params?.categoryId) {
                    search.categoryId = params.categoryId;
                }
                if (params?.level) {
                    search.level = params.level;
                }
                if (params?.isPremium !== undefined) {
                    search.isPremium = params.isPremium ? 'true' : 'false';
                }
                if (params?.isFree !== undefined) {
                    search.isFree = params.isFree ? 'true' : 'false';
                }
                if (params?.isUserContent !== undefined) {
                    search.isUserContent = params.isUserContent ? 'true' : 'false';
                }
                if (params?.authorId) {
                    search.authorId = params.authorId;
                }
                if (params?.limit !== undefined) {
                    search.limit = String(params.limit);
                }
                if (params?.offset !== undefined) {
                    search.offset = String(params.offset);
                }
                return {
                    url: '/courses',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (raw: unknown): Courses.GetCoursesResponse =>
                parseWithSchema(Courses.GetCoursesResponseSchema, raw),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((c) => ({
                            type: 'Course' as const,
                            id: c.id
                        })),
                        { type: 'Course' as const, id: 'LIST' }
                    ]
                    : [{ type: 'Course' as const, id: 'LIST' }]
        }),

        getCourse: build.query<Courses.GetCourseResponse, { id: string }>({
            query: ({ id }) => ({
                url: `/courses/${id}`,
                method: 'GET'
            }),
            transformResponse: (raw: unknown): Courses.GetCourseResponse =>
                parseWithSchema(Courses.GetCourseResponseSchema, raw),
            providesTags: (_result, _error, arg) => [{ type: 'Course', id: arg.id }]
        })
    })
});

export const { useListCoursesQuery, useGetCourseQuery } = coursesApi;
